import * as React from 'react';
import styled from 'styled-components';

import { Markdown } from 'components/common';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';
import { EmptyList, TD } from 'security-app/components/common';

import RowActionMenu from './RowActionMenu';

const MarkdownStyles = styled.div`
  overflow: hidden auto;
  height: 100%;
  padding: 0 8px;

  container-type: inline-size;

  & > div {
    & > h1,
    & > h2,
    & > h3,
    & > h4,
    & > h5,
    & > h6 {
      margin-bottom: 8px;
      font-family: ${({ theme }) => theme.fonts.family.body};
    }

    & > hr {
      margin: 16px 0;
      border: none;
      border-bottom: 1px solid ${({ theme }) => theme.colors.brand.tertiary};
    }

    & ul,
    & ol {
      padding-left: 1.5rem;
      margin: 8px 0;

      & > li {
        padding: 4px 0;
      }
    }

    & ul {
      list-style-type: disc;
    }

    & p {
      white-space: pre-wrap;
      margin: 8px 0;
    }

    & table {
      border-collapse: collapse;
      border-spacing: 0;
      margin: 8px 0;

      & th,
      & td {
        border: 1px solid ${({ theme }) => theme.colors.input.border};
        padding: 4px 8px;
      }
    }
  }
`;

type Props = {
  eventProcedureSteps: EventProcedureStepAPIType[];
};

function ListRows({ eventProcedureSteps }: Props) {
  return eventProcedureSteps.length < 1 ? (
    <EmptyList
      noSearchResultText="No Event Procedures found for the provided criteria"
      noEntitiesExist="Currently there are no Event Procedures to list"
      colSpan={3}
    />
  ) : (
    <>
      {eventProcedureSteps.map((eventProcedureStep: EventProcedureStepAPIType) => (
        <tr key={`event-procedure-steps-row-${eventProcedureStep.id}`} data-testid="event-procedure-steps-row">
          <TD>{eventProcedureStep.title}</TD>
          <TD>
            <MarkdownStyles>
              <Markdown text={eventProcedureStep.description} />
            </MarkdownStyles>
          </TD>
          <TD>
            <RowActionMenu eventProcedureStep={eventProcedureStep} />
          </TD>
        </tr>
      ))}
    </>
  );
}

export default ListRows;
